import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { length } from '../../../../../common/utils/immutableHelper';
import { CellTypeConstants, CellTypeNames } from '../../../../../common/table/CellTypeConstants';
import { SheetId } from '../../../../mobile/structural/sheet/sheetTypes';
import useSheet from '../../../../mobile/structural/sheet/hooks/useSheet';
import Icon from '../../../../components/icons/Icon';
import ToolbarTool from '../../../../workspace/toolbar/components/ToolbarTool';
import { useActiveTableSelector } from '../../bridge/store/hotTableStoreHooks';
import {
    selectActiveTableSharedCellTypeFormatOptions,
} from '../store/selectors/activeHotTableSelectors';
import { selectActiveTableCellSelection } from '../../bridge/store/selectors/activeHotTableCellSelectionSelectors';
import { userLanguagePreferenceSelector } from '../../../../user/currentUserSelector';
import MobileCellTypeSheet from './MobileCellTypeSheet';

type MobileCellTypeToolProps = {
    name: string;
    gridSize: number;
};

const MobileCellTypeTool = ({ name, gridSize }: MobileCellTypeToolProps): ReactElement => {
    const locale = useSelector(userLanguagePreferenceSelector);
    const sheetProps = useSheet(SheetId.TableCellTypeTool);
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);
    const sharedCellTypeFormatOptions = useActiveTableSelector(selectActiveTableSharedCellTypeFormatOptions);
    const activeCellType: CellTypeNames | undefined = sharedCellTypeFormatOptions?.name;
    const [lastClickedType, setLastClickedType] = useState<CellTypeNames | null>(null);

    useEffect(() => {
        setLastClickedType(null);
    }, [currentCellSelections]);

    const isDisabled = length(currentCellSelections) === 0;
    const iconName = activeCellType ? CellTypeConstants[activeCellType]?.icon : 'toolbar-cell-type';

    return (
        <>
            <ToolbarTool
                name={name}
                isOpen={sheetProps.isOpen}
                disabled={isDisabled}
                onClick={isDisabled ? undefined : () => sheetProps.openSheet()}
            >
                <Icon gridSize={gridSize} name={iconName} />
            </ToolbarTool>
            <MobileCellTypeSheet
                sheetProps={sheetProps}
                locale={locale}
                activeCellType={activeCellType}
                sharedCellTypeFormatOptions={sharedCellTypeFormatOptions}
                lastClickedType={lastClickedType}
                setLastClickedType={setLastClickedType}
            />
        </>
    );
};

export default MobileCellTypeTool;
